import React from 'react';

import {SmallLoader} from '@kit';

import {getApolloError} from '../../../../components/utils';
import {Spell, useSpellQuery} from '../../../../generated/types';
import {SpellDetails} from '../../../spells/view/spell-details';

import css from './sheet.module.css';

type Props = {
	spellId: string;
};

export const SpellDescription: React.FC<Props> = ({spellId}) => {
	const {data, loading, error} = useSpellQuery({variables: {id: spellId}});
	if (loading) return <SmallLoader />;
	if (error) return <div className={css.muted}>{getApolloError(error).message}</div>;
	if (!data?.spell) return null;
	return (
		<div className={css.spellDescription}>
			<SpellDetails spell={data.spell as Spell} />
		</div>
	);
};
